<template>
    <div class="master_nav__line-wrap">
        <h6 class="master_nav__label">
            <span>{{ label }}</span>
        </h6>
    </div>
</template>

<script>
export default {
    name: 'DivLine',
    props: {
        label: { type: String, required: true },
    },
};
</script>
